// Papéis de membros dentro de uma empresa (multi-tenancy).

export const PAPEIS_EMPRESA = [
  { value: "administrador", label: "Administrador" },
  { value: "operador_estoque", label: "Operador de Estoque" },
  { value: "operador_entrega", label: "Operador de Entrega" },
];

const PAPEL_LABELS = {
  administrador: "Administrador",
  operador_estoque: "Operador de Estoque",
  operador_entrega: "Operador de Entrega",
};

// Retorna o rótulo amigável de um papel; cai no próprio valor se desconhecido.
export const getPapelLabel = (papel) => PAPEL_LABELS[papel] || papel || "-";

// Cores de Chip do MUI para cada papel.
export const getPapelColor = (papel) => {
  switch (papel) {
    case "administrador":
      return "error";
    case "operador_estoque":
      return "secondary";
    case "operador_entrega":
      return "info";
    default:
      return "default";
  }
};

// Tela inicial de cada papel na empresa ativa. O /dashboard só funciona para o
// `administrador` (GET /relatorios/dashboard devolve 403 para os operadores),
// então cada operador começa na sua área. Sem papel (usuário ainda sem empresa)
// a saída é /empresa, onde ele cria ou escolhe uma. Usada pela rota inicial, pelo
// destino de bloqueio do ProtectedRoute e pelo login.
const ROTA_INICIAL = {
  administrador: "/dashboard",
  operador_estoque: "/estoque",
  operador_entrega: "/pedidos",
};

export const rotaInicialPorPapel = (papel) =>
  ROTA_INICIAL[papel] || "/empresa";
